import React from 'react'
import LegalNotice from './LegalNotice'

const Branding = (props) => {

  return (
  <div className="fineryContent">
    <div className="contentLogo">
      <a href="http://www.match.com" target="_blank" rel="noopener noreferrer" className="matchLogo"><span style={{textIndent: '-9999px'}}>Match</span></a>
      <a href="http://www.finery.com/signup/match" target="_blank" rel="noopener noreferrer" className="fineryLogo"><span style={{textIndent: '-9999px'}}>Finery</span></a>
    </div>
        {props.children}
        <LegalNotice />
  </div>

  )
}

export default Branding



// WEBPACK FOOTER //
// ./src/templates/Branding.js